import React, { useState, useCallback } from 'react';
import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import _ from 'lodash';
import './autocomplete.scss'

// Fonction pour échapper les caractères spéciaux regex
const escapeRegexCharacters = str => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

// Fonction pour obtenir la valeur d'une suggestion
const getSuggestionValue = suggestion => {
    return `${suggestion.label}`;
};

// Fonction pour le rendu des suggestions avec mise en surbrillance
const renderSuggestion = (suggestion, { query }) => {
    const suggestionText = `${suggestion.label}`;
    const matches = AutosuggestHighlightMatch(suggestionText, query);
    const parts = AutosuggestHighlightParse(suggestionText, matches);

    return (
        <span className={'suggestion-content ' + suggestion.twitter}>
            <span className="name">
                {parts.map((part, index) => {
                    const className = part.highlight ? 'highlight' : null;
                    return (
                        <span className={className} key={index}>
                            {part.text}
                        </span>
                    );
                })}
            </span>
        </span>
    );
};

const Autocomplete = ({
                                   data = [],
                                   defaultValue = '',
                                   onBlur,
                                   placeholder = '',
                                   label = '',
                                   error = '',
                                   disabled = false,
                                   name = '',
                                   additional_label = '',
                                   showLabel = true,
                                   isValid = false,
                                   required = false,
                          setFieldValue,
                                   setQuery = false
                               }) => {
    const [value, setValue] = useState(defaultValue || '');
    const [suggestions, setSuggestions] = useState([]);

    const getSuggestions = useCallback((inputValue) => {
        const escapedValue = escapeRegexCharacters(inputValue.trim());

        if (escapedValue === '') {
            return [];
        }

        const regex = new RegExp('\\b' + escapedValue, 'i');
        return _.slice(data.filter(item => regex.test(getSuggestionValue(item))), 0, 10);
    }, [data]);

    const handleChange = (event, { newValue }) => {
        setValue(newValue);

        if (setQuery) {
            setQuery(newValue);
        }

        let item = _.find(suggestions, ['label', newValue]);

        if (!item) {
            item = _.find(data, ['label', newValue]);
        }

        if (item) {
            setFieldValue(name, item.value);
        } else {
            setFieldValue(name, '');
        }
    };

    // Gestion de la sélection directe d'une suggestion
    const onSuggestionSelected = (event, { suggestion }) => {
        setFieldValue(name, suggestion.value);
    };

    // Gestion des demandes de suggestions
    const onSuggestionsFetchRequested = ({ value }) => {
        const newSuggestions = getSuggestions(value);
        setSuggestions(newSuggestions);
    };

    // Gestion de la suppression des suggestions
    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const inputProps = {
        placeholder: placeholder || '',
        value,
        onChange: handleChange,
        onBlur: onBlur,
        disabled: disabled,
        name: name,
        className: `form-control ${error ? 'is-invalid' : ''}`,
        required: required
    };

    return (
        <div className={`form-group autocomplete ${isValid ? 'success-input' : error ? 'error-input' : ''}`}>
            {showLabel && (
                <label className={value ? 'active' : ''}>
                    {additional_label && <b>{additional_label}</b>} {label}
                </label>
            )}

            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                onSuggestionSelected={onSuggestionSelected}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
                focusInputOnSuggestionClick={true}
            />

            {error && <small className={'text-danger fst-italic'}>{error}</small>}
        </div>
    );
};

export default Autocomplete;